import React, { Component } from 'react';
import * as firebase from 'firebase';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
  Link,
  Redirect
} from "react-router-dom";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from "@material-ui/core/FormControl";
import '../view/css/Search.css';
import { NavBarGuest, NavBarAffiliate, NavBarUser } from "../view/NavBar";
import { AffiliateSearchResult } from "../view/AffiliateSearchResult"
import { CreateEvent } from '../model/event_model/CreateEvent';
import Pagination from "react-js-pagination";

// var firebaseConfig = {
//   apiKey: "AIzaSyAZxEY5MJyAgu5Eta8cGk9JxLSvNp9PL5U",
//   authDomain: "breeze-b933b.firebaseapp.com",
//   databaseURL: "https://breeze-b933b.firebaseio.com",
//   projectId: "breeze-b933b",
//   storageBucket: "breeze-b933b.appspot.com",
//   messagingSenderId: "52860641709",
//   appId: "1:52860641709:web:705b28bb0f6946d8008124",
//   measurementId: "G-79BZE0QM7K"
// };


// var firebaseConfig = {
//   apiKey: "AIzaSyAZxEY5MJyAgu5Eta8cGk9JxLSvNp9PL5U",
//   authDomain: "breeze-b933b.firebaseapp.com",
//   databaseURL: "https://breeze-b933b.firebaseio.com",
//   projectId: "breeze-b933b",
//   storageBucket: "breeze-b933b.appspot.com",
//   messagingSenderId: "52860641709",
//   appId: "1:52860641709:web:705b28bb0f6946d8008124",
//   measurementId: "G-79BZE0QM7K"
// };
// // Initialize Firebase
// firebase.initializeApp(firebaseConfig);
var firestore = firebase.firestore();
//var user = firebase.auth().currentUser;
const db = firestore.collection("Tag");
const affiliates = firestore.collection("Users").where("type", "==", "Affiliate");
var display = [];
var result = [];
var pushed = [];

// Access all tags from firestore
const affiliateList = [affiliates];
var tags = [];
var user = null;


class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retrieved: false,
      default: true,
      searchText: "",
      searchResults: [],
      showMenu: false,
      tags2: [],
      selectedTags: [],
      num: 0,
      type_1: "",
      userLoaded: false,
      activePage: 1
    };

    this.getTags = this.getTags.bind(this);
    this.handleText = this.handleText.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
  }

  user = firebase.auth().currentUser;

  componentDidMount = () => {
    console.log("I MOUNTED");
    this.getTags();

  } 

  runThis = () => {
    if (firebase.auth().currentUser) {
      const ab = firestore.collection("Users").doc(firebase.auth().currentUser.email);
      const doc = ab.get().then((doc) => {
        this.setState({ type_1: doc.data().type });
        this.setState({ userLoaded: true });
      });
    }

  }

  handleText = (e) => {
    this.setState({ retrieved: false });
    e.preventDefault();
    const value = document.getElementById("SearchInput").value;
    //Store search input as a state
    console.log("search result is " + value /*e.target.value*/);
    // this.setState({ searchText: value /*e.target.value*/ });
    // console.log("SearchText = " + this.state.searchText);
    // this.retrieveAffiliates(); 

    this.setState({ searchText: value }, function () {
      console.log("SEARCHED: " + this.state.searchText)
      this.retrieveAffiliates();
    });
  }

  defaultSearch = () => {
    this.setState({ retrieved: false });
    this.setState({ default: false });
    const value = "";
    //Store search input as a state
    console.log("Default search result is " + value /*e.target.value*/);
    // this.setState({ searchText: value /*e.target.value*/ });
    // console.log("SearchText = " + this.state.searchText);
    // this.retrieveAffiliates(); 

    this.setState({ searchText: value }, function () {
      console.log("SEARCHED: " + this.state.searchText)
      this.retrieveAffiliates();
      display = result.slice(0, 2);
      console.log("display ran")
    });
  }

  handleChecklist = (e) => {
    e.preventDefault();
    //store search input as state
    this.setState({ searchResults: e });
  }

  handleCheck = (e) => {
    console.log("name = " + e.target.id);
    console.log(e);
    if (this.state.selectedTags.includes(e.target.id)) {
      var copy = [...this.state.selectedTags];
      console.log(copy)
      var index = copy.indexOf(e.target.id);
      if (index !== -1) {
        copy.splice(index, 1);
        this.setState({ selectedTags: copy });
      }
    } else {
      this.setState(prevState => ({
        selectedTags: [...prevState.selectedTags, e.target.id]
      }))
    }
    this.retrieveAffiliates();
    console.log("Selected tags = " + this.state.selectedTags);
  }

  retrieveAffiliates() {
    // Case 1: Input no tags: Returns results
    // Case 2: Only tags no input: REturns based on tags
    // Case 3: Tags -> input: Filters through tags first then based on input
    // This will need to ensure that tags + filters doesnt add duplicates
    // Case 4: Input put in -> then tags
    const searched = this.state.searchText.toLowerCase();
    console.log("searched: " + searched);
    result = []
    pushed = []
    affiliates
      .get()
      .then((data) => {
        data.forEach((doc) => {
          const dataList = doc.data();
          // Default search page: 
          if ((this.state.selectedTags.length == 0 && (searched == ""))) {
            result.push([dataList.username, [dataList.description, dataList.profile_pic, dataList.id, dataList.interests]]);
            pushed.push(dataList.username);
            console.log("Affiliate: " + dataList.username);
            console.log("Tags + Search");
            this.setState({ retrieved: true });
          }
          //Checks that there are tags and an input
          else if (this.state.selectedTags.length !== 0 && (searched !== "")) {
            // Result and pushed will have contents
            // Go through the contents and remove any that dont match
            this.state.selectedTags.forEach(element => {
              if (dataList.interests.includes(element)) {
                if ((!pushed.includes(dataList.username)) && (dataList.username.toLowerCase().includes(searched) || dataList.description.toLowerCase().includes(searched))) {
                  // Might need to change
                  result.push([dataList.username, [dataList.description, dataList.profile_pic, dataList.id, dataList.interests]]);
                  pushed.push(dataList.username);
                  console.log("Affiliate: " + dataList.username);
                  console.log("Tags + Search");
                  this.setState({ retrieved: true });
                }
              }
            });
          }
          // Checks tags
          else if (this.state.selectedTags.length !== 0) {
            this.state.selectedTags.forEach(element => {
              if ((!pushed.includes(dataList.username)) && dataList.interests.includes(element)) {
                result.push([dataList.username, [dataList.description, dataList.profile_pic, dataList.id, dataList.interests]]);
                pushed.push(dataList.username);
                console.log("Affiliate: " + dataList.username);
                this.setState({ retrieved: true });
              }
            });
          }
          // Checks if input string is empty
          else if (searched !== "") {
            console.log("HELLO1");
            // Checks if the affiliate is already displayed
            if (!pushed.includes(dataList.username)) {
              console.log("HELLO2");
              if (dataList.username.toLowerCase().includes(searched) || dataList.description.toLowerCase().includes(searched)) {
                //result[dataList.username] = [dataList.description, dataList.photos];
                result.push([dataList.username, [dataList.description, dataList.profile_pic, dataList.id, dataList.interests]]);
                pushed.push(dataList.username);
                console.log("Affiliate: " + dataList.username);
                this.setState({ retrieved: true });
              }
            }
          }
        });
        this.setState({ activePage: 1 })
      })
      .catch(function (error) {
        console.log("Error getting documents: ", error);
      });
  }

  getTags = () => {
    db.get().then((data) => {
      data.forEach((doc) => {
        //add each doc.id into tags
        var tagName = doc.data().name; //let tags = tags.push(doc.id)
        this.setState(prevState => ({
          tags2: [...prevState.tags2, tagName]
        }))
      });
    });

    this.listTags();
  }

  listTags = () => {
    tags.map((name) => (
      this.setState(prevState => ({
        tags2: [...prevState.tags2, name]
      }))
    ));
  }

  getDescription = (listing) => {
    if (listing[1][0] == "") {
      return "This affiliate currently has no description. Visit to learn more!"
    }
    return listing[1][0];
  }

  handlePageChange(pageNumber) {
    console.log(`active page is ${pageNumber}`);
    this.setState({ activePage: pageNumber });
  }

  displayed = (pageNumber) => {
    var initial = 0;
    if (pageNumber > 1) {
      initial = 4 * (pageNumber - 1);
    }
    const end = initial + 4;
    return (result.slice(initial, end));
  }

  render() {
    return (
      <div>
        {!this.state.userLoaded && this.runThis()}
        {this.state.type_1 === "" ? <NavBarGuest /> : this.state.type_1 === "Student" ? <NavBarUser /> : <NavBarAffiliate />}
        {this.state.default && this.defaultSearch()}



        <div className="Explore">
          {/* filters */}
          <div className="Filters">
            <div className="Searchbar">
              <form className="SearchForm">
                <h4 className="SearchText">Search</h4>
                <label>
                  <input type="text" id="SearchInput" placeholder="Enter a search" />
                  <button className="submitBtn" onClick={this.handleText}>Submit</button>
                </label>
              </form>
            </div>

            <h4 className="TagLister2">Tags</h4>
            {this.state.tags2.map((name) => (
              <div className="TagListing">
                {name !== undefined && <input className="Checkbox" type="checkbox" id={name} name={name} value={true} onChange={e => this.handleCheck(e)} />}
                {name !== undefined && <p className="TagName">{name}</p>}
              </div>
            ))}
          </div>

          {/* {this.state.retrieved && <div className="Affiliates"> 
            {console.log("Result length: " +result.length)}
            <div className="AffiliateListing">
              {result.map((listing) => (
                listing[0] && <AffiliateSearchResult name={listing[0]} description={this.getDescription(listing)} photos={listing[1][1]} id={listing[1][2]} tags={listing[1][3]}/>
              ))}
            </div> */}

          <div className="PaginatorContainer">

            <div className="Paginator">
              <Pagination
                activePage={this.state.activePage}
                itemsCountPerPage={4}
                totalItemsCount={result.length}
                pageRangeDisplayed={Math.ceil(result.length / 2)}
                onChange={this.handlePageChange.bind(this)}
              />
            </div>

            {/* affiliate listings*/}
            {this.state.retrieved &&
              <div className="Affiliates">
                {this.displayed(this.state.activePage).map((listing) => (
                  listing[0] && <AffiliateSearchResult name={listing[0]} description={listing[1][0]} photos={listing[1][1]} id={listing[1][2]} tags={listing[1][3]} />
                ))}
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default Search;